import { createFileRoute, redirect } from "@tanstack/react-router";
import { isAuthenticated, fetchMe } from "@/lib/auth";

// `validateSearch` and `beforeLoad` stay in this eager file so the router
// can parse URL params and run the auth-bounce check before deciding which
// chunk to load. The component (form UI, OAuth buttons) lives in
// `index.lazy.tsx` so it isn't downloaded for already-authenticated visits
// that bounce away here.
export const Route = createFileRoute("/login/")({
  validateSearch: (search: Record<string, unknown>) => {
    const out: { error?: string; email?: string } = {};
    if (typeof search.error === "string" && search.error) out.error = search.error;
    if (typeof search.email === "string" && search.email) out.email = search.email;
    return out;
  },
  beforeLoad: async () => {
    if (!isAuthenticated()) return;
    const auth = await fetchMe();
    if (auth) {
      throw redirect({ to: "/" });
    }
    // Token was stale/revoked — fetchMe() already cleared it via clearToken().
    // Fall through to the login form.
  },
});
